'use client';

import { AppImageClient, AppImageData } from '@components/appImage';
import { Carousel } from '@components/carousel';
import { VideoPlayer } from '@components/videoPlayer';
import { useEffect, useRef, useState } from 'react';

import { VideoPlayerProps } from '../../videoPlayer/ui/types';

import { SCREEN_SM } from '@/shared/constants/common';

export interface MediaCarouselProps {
  videos?: VideoPlayerProps[];
  pagination?: boolean | { clickable: boolean };
  catalogImagesPrint?: {
    alt: string;
    imageData: AppImageData;
  }[];
  countSlider?: number;
}

export const MediaCarousel = ({
  videos,
  pagination,
  catalogImagesPrint,
  countSlider = 1,
}: MediaCarouselProps) => {
  const swiperContainerRef = useRef<HTMLDivElement>(null);
  const [isMobile, setIsMobile] = useState<boolean>();

  const onSlideChange = () => {
    if (!swiperContainerRef.current) {
      return;
    }

    const swiperContainerNode = swiperContainerRef.current;

    swiperContainerNode
      .querySelectorAll<HTMLVideoElement>('video')
      .forEach((video) => {
        if (video.paused) {
          return;
        }
        video.pause();
      });
  };

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    const handleResize = () => setIsMobile(window.innerWidth <= SCREEN_SM);

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div ref={swiperContainerRef} className="w-full">
      <Carousel
        loop
        variant="main"
        spaceBetweenSlides={32}
        navigation={!isMobile}
        pagination={pagination}
        navigationButtonsType="square"
        onSlideChange={onSlideChange}
        countSlider={countSlider}
      >
        {videos?.map((video, index) => (
          <Carousel.Item
            key={index}
            className="flex h-full w-full items-center justify-center"
          >
            <div className={'flex h-full w-full items-center justify-center'}>
              <VideoPlayer {...video} />
            </div>
          </Carousel.Item>
        ))}
        {catalogImagesPrint?.map(({ imageData, alt }, index) => (
          <Carousel.Item
            key={index}
            className="flex h-full w-full items-center justify-center"
          >
            <div
              className={
                'rounded-20 flex items-center justify-center overflow-hidden'
              }
            >
              <AppImageClient {...imageData} alt={alt} />
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
};
